import { parseDomain, ParseResultType } from 'parse-domain';
import { z } from 'zod';

export const INVALID_ADDR_ERR = 'Invalid IPv4 address or hostname';
export const NO_TRAILING_DOT = 'Hostname must not have a trailing dot';

function validateListenHost(ipOrHostname: string): string | true {
  const parseResult = parseDomain(ipOrHostname);

  switch (parseResult.type) {
    case ParseResultType.NotListed:
    case ParseResultType.Listed:
    case ParseResultType.Reserved: {
      if (parseResult.hostname.endsWith('.')) {
        return NO_TRAILING_DOT;
      }
      return true;
    }
    case ParseResultType.Ip: {
      return true;
    }
    case ParseResultType.Invalid: {
      return INVALID_ADDR_ERR;
    }
    default:
      throw new Error(INVALID_ADDR_ERR);
  }
}

export const listenHostSchema = z.string().superRefine((arg, ctx) => {
  const result = validateListenHost(arg);

  if (typeof result === 'string') {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: result,
      fatal: true,
    });

    return z.NEVER;
  }

  return z.NEVER;
});

export const requiredListenHostSchema = listenHostSchema.refine((val) => val !== '', {
  message: 'Provide a hostname or IP address',
});
